import { useState } from "react";
import { Card } from "../../../components/base/Card";
import { TextField } from "../../../components/base/TextField";
import { Textarea } from "../../../components/base/Textarea";
import { Select } from "../../../components/base/Select";
import { MultiSelect } from "../../../components/base/MultiSelect";
import { RadioGroup } from "../../../components/base/RadioGroup";
import { Checkbox } from "../../../components/base/Checkbox";
import { Toggle } from "../../../components/base/Toggle";
import { DatePicker } from "../../../components/base/DatePicker";
import { DateRangePicker } from "../../../components/base/DateRangePicker";
import { FileUpload } from "../../../components/base/FileUpload";
import { CurrencyInput } from "../../../components/currency/CurrencyInput";
import { GALLERY_GROUP_OPTIONS } from "../../../mocks/gallery";

const CITIES = [
  { value: "mumbai", label: "Mumbai" },
  { value: "delhi", label: "Delhi" },
  { value: "pune", label: "Pune" },
  { value: "chennai", label: "Chennai" },
  { value: "jaipur", label: "Jaipur" },
];

export function ControlsSection() {
  const [email, setEmail] = useState("");
  const [city, setCity] = useState<string | null>("mumbai");
  const [groups, setGroups] = useState<string[]>(["laxmi-12"]);
  const [payment, setPayment] = useState("upi");
  const [agreed, setAgreed] = useState(false);
  const [notify, setNotify] = useState(true);
  const [date, setDate] = useState<string | null>(null);
  const [range, setRange] = useState<{ start: string | null; end: string | null }>({ start: null, end: null });
  const [amount, setAmount] = useState<number | null>(null);
  const [files, setFiles] = useState<File[]>([]);

  return (
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
      <Card title="Text inputs">
        <div className="space-y-4">
          <TextField label="Email" name="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          <TextField label="Email (error state)" name="email-error" defaultValue="invalid@example" error="Please enter a valid email address." />
          <TextField label="Full name" helper="Shown to members and in reports." placeholder="Ramesh Gupta" />
          <TextField label="Disabled field" value="Read-only value" disabled />
          <TextField label="With search icon" placeholder="Search members…" leftIcon="ri-search-line" />
          <TextField label="With action icon" placeholder="Type a code" rightIcon="ri-scan-line" />
        </div>
      </Card>

      <Card title="Selects & multi-select">
        <div className="space-y-4">
          <Select label="City" value={city} onChange={setCity} options={CITIES} searchable clearable />
          <Select label="Group (error)" error="A group is required." value={null} onChange={() => {}} options={GALLERY_GROUP_OPTIONS} placeholder="Choose a group…" />
          <MultiSelect label="Groups" values={groups} onChange={setGroups} options={GALLERY_GROUP_OPTIONS} helper="Select one or more groups." />
          <Select label="Disabled" value="mumbai" onChange={() => {}} options={CITIES} disabled />
        </div>
      </Card>

      <Card title="Choice controls">
        <div className="space-y-5">
          <RadioGroup
            label="Payment method"
            value={payment}
            onChange={setPayment}
            direction="horizontal"
            options={[
              { value: "cash", label: "Cash" },
              { value: "upi", label: "UPI" },
              { value: "bank", label: "Bank transfer" },
            ]}
          />
          <Checkbox label="I agree to the terms" description="Confirm you have the authority to collect on behalf of this group." checked={agreed} onChange={setAgreed} />
          <Checkbox label="Disabled checkbox" checked description="This option is not available." disabled />
          <Toggle label="Send collection reminders" description="Notify members 2 days before the due date." checked={notify} onChange={setNotify} />
        </div>
      </Card>

      <Card title="Textarea & dates">
        <div className="space-y-4">
          <Textarea label="Notes" placeholder="Add remarks about this collection…" helper="Optional notes shown in the ledger." maxLength={500} />
          <DatePicker label="Collection date" value={date} onChange={setDate} />
          <DateRangePicker value={range} onChange={setRange} />
        </div>
      </Card>

      <Card title="Currency input">
        <div className="space-y-4">
          <CurrencyInput label="Monthly subscription" name="subscription" value={amount} onChange={setAmount} helper="Loses focus to apply Indian lakh/crore grouping." />
          <CurrencyInput label="Over-limit error" error="Amount exceeds the group cap." value={999999} onChange={() => {}} />
          <CurrencyInput label="Disabled" value={50000} onChange={() => {}} disabled />
        </div>
      </Card>

      <Card title="File upload">
        <div className="space-y-4">
          <FileUpload
            label="Collection receipts"
            value={files}
            onChange={setFiles}
            accept=".pdf,.jpg,.png"
            multiple
            helper="Upload scanned receipts for audit."
          />
        </div>
      </Card>
    </div>
  );
}